angular.module('gym.components').directive('waiverAnswers', ["$timeout", function($timeout) {
  return {
    restrict: 'E',
    scope: {
      data: '='
    },
    template: require('templates/components/contacts/comms/waiver_answers.html.slim'),
    controller: ["$scope", function($scope) {
      $scope.visible = false;
      return $scope.toggle = function() {
        return $scope.visible = !$scope.visible;
      };
    }]
  };
}]);
